import { combineReducers } from 'redux';

import Account from './Account';
import Activity from './Activity';
import Application from './Application';
import Board from './Board';
import Group from './Group';
import Member from './Member';
import Memo from './Memo';
import Network from './Network';
import Note from './Note';
import Wiki from './Wiki';

const reducers = combineReducers({
  Application,
  Account,
  Group,
  Member,
  Memo,
  Note,
  Wiki,
  Board,
  Activity,
  Network
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.ts